/**
 * Copyright 2026 Google LLC.
 * Copyright (c) Microsoft Corporation.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * THIS FILE IS AUTOGENERATED by cddlconv 0.2.0.
 * Run `tools/update_bidi_types.py` to regenerate.
 * @see https://github.com/w3c/webdriver-bidi/blob/master/index.bs
 */

import type {EmptyResult} from './webdriver-bidi.js';

export namespace DigitalCredentials {
  export const VirtualWalletAction = {
    Decline: 'decline',
    Respond: 'respond',
    Wait: 'wait',
    Clear: 'clear',
  } as const;
  export type VirtualWalletAction =
    (typeof VirtualWalletAction)[keyof typeof VirtualWalletAction];
}
export namespace DigitalCredentials {
  export type SetVirtualWalletBehaviorParameters = {
    action: DigitalCredentials.VirtualWalletAction;
    context?: string;
    protocol?: string;
    response?: {
      [key: string]: any;
    };
  };
}
export namespace DigitalCredentials {
  export type SetVirtualWalletBehavior = {
    method: 'digitalCredentials.setVirtualWalletBehavior';
    params: DigitalCredentials.SetVirtualWalletBehaviorParameters;
  };
}
export namespace DigitalCredentials {
  export type SetVirtualWalletBehaviorResult = EmptyResult;
}
